 export const UNLICENSED_AGENT_CODE = 'SFG0083625'
 export const TEAM_LEADER_AGENT_CODE = 'SFG0037732'
 export const SFG_DIRECT_AGENT_CODE = 'SFG0008482'

 export const DISABLED_PAGES_IN_DEMO_MODE = [
    '/page/agent-bio',
    '/page/key-leader-academy',
    '/page/master-commission-schedule',
    '/page/agency-owner-academy',
]